import React, { useState, useEffect } from "react";

function Logo({ width = 100, height = 100 }) {
  const [logo, setLogo] = useState([]);
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) {
          throw new Error("Failed to fetch promotions");
        }
        const data = await response.json();
        setLogo(data[0].mobile_logo);
        // setLogo(data[0].logo);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);
  // src={`${process.env.REACT_APP_API_URL}/storage/${logo}`}
  return (
    // <div className="logo"  style={{ backgroundImage: `url('${process.env.REACT_APP_API_URL}/storage/${logo}')` }}></div>
    <img
      src={`${process.env.REACT_APP_API_URL}/storage/${logo}`}
      alt="logo"
      style={{ width: width, height: height }}
      className="logo"
    />

  );
}
export default Logo;